// extracted by mini-css-extract-plugin
module.exports = {"cta":"Link_cta__kpX41","decoration":"Link_decoration__nR6hJ","rotation":"Link_rotation__AaXqD"};